import { jsxs as p, jsx as t } from "@emotion/react/jsx-runtime";
import { Line as l } from "./Line.js";
import { List as a } from "./List.js";
import { StyledContainer as f, StyledDiv as d } from "./Skeleton.styled.js";
import { BusinessCards as u } from "./BusinessCards/BusinessCards.js";
const C = {
  line: l,
  list: a,
  businessCards: u
}, y = ({
  variant: n = "list",
  row: r,
  col: s,
  className: e,
  width: o = 120,
  showContainer: m = !0
}) => {
  const i = C[n];
  return m ? /* @__PURE__ */ p(f, { className: e, children: [
    /* @__PURE__ */ t(i, { row: r, col: s, width: o }),
    /* @__PURE__ */ t(d, {})
  ] }) : /* @__PURE__ */ t(i, { row: r, col: s, width: o });
};
export {
  y as Skeleton
};
